import * as React from "react";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { DistributionDividendPreference } from "../../../../../../Wrap/Constants/Enums/Domain/DistributionDividendPreference";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { MoneyOrPercentageType } from "../../../../../../Wrap/Constants/Enums/MoneyOrPercentageType";
import { GiaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { IsaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { WhatIfToolDetailModel } from "../../../../../../Wrap/Models/Models/Processes/WhatIfTool/WhatIfToolDetailModel";
import { CheckboxGroup } from "../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ClientAccountStore } from "../../../../Stroes/Variable";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { SectionHeader } from "../../Common/SharedComponents";
import { whatIfModelArray, whatIfSippModelArray, whatifProcess } from "../Resource/Contents";
import { PensionArrangement } from "../../../../../../Wrap/Models/Models/Account/PensionArrangement";
import { PensionArrangementStatus } from "../../../../../../Wrap/Constants/Enums/Drawdown/PensionArrangementStatus";
import { RegularDrawdown } from "../../../../../../Wrap/Models/Domains/Drawdown/RegularDrawdown";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { PensionArrangementType } from "../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { Action } from "../../../../Actions/Action";
import { PensionArrangementAction } from "../../PortfolioDashboard/Components/ProductOverview/Action/PensionArrangementValuationAction";
import { PensionArrangementValuation } from "../../../../../../Wrap/Models/Models/Account/PensionArrangementValuation";

interface IChangesToTheModelProps extends IProcessComponentProps {
    data: GiaContributionModel | IsaContributionModel | PensionContributionModel;
    type: SubAccountType;
    extraInfo: WhatIfToolDetailModel;
    pensionArrangements: PensionArrangement[];
    regularDrawdown?: RegularDrawdown;
}

interface IChangesToTheModelState { 
    pensionArrangements: PensionArrangement[];
    pensionArrangementValuations: PensionArrangementValuation[];
}

export class ChangesToTheModel extends ProcessComponent<IChangesToTheModelProps, IChangesToTheModelState> {
    constructor(props: any) {
        super(props);
        this.state = {
            pensionArrangements: [],
            pensionArrangementValuations: []
        };
    }
    
    componentDidMount(): void {
        const subaccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        if (this.props.type == SubAccountType.Npr || this.props.type == SubAccountType.JuniorSipp) {
            PensionArrangementAction.GetPensionArrangementDetails(subaccountHierarchyId, false, (pensionArrangementDetailsResult) => {
                if (pensionArrangementDetailsResult && pensionArrangementDetailsResult.length > 0) {
                    PensionArrangementAction.GetPensionArrangementValuation([subaccountHierarchyId], true, (pensionArrangementValuationResult) => {
                        if (pensionArrangementValuationResult && pensionArrangementValuationResult.length > 0) {
                            this.setState({
                                pensionArrangementValuations: pensionArrangementValuationResult,
                                pensionArrangements: pensionArrangementDetailsResult
                            });
                        }
                    });
                }
            });
        }
    }

    isValid() {
        if (this.props.data?.Contribution?.ChangesToBeModeled.split(",").filter((ele) => ele != "").length == 0) {
            this.props.showErrorMsgPopUp(["Please at least select one model"]);
            return false;
        }
        return super.isValid();
    }

    private clearData = (model: whatifProcess) => {
        const { data, onChange, type } = this.props;
        const transferName = SubAccountTypeHelper.isPP(type) ? "GiaTransfers" : "IsaTransfers";
        const originSelected = (data?.Contribution?.ChangesToBeModeled || "").split(",");
        switch (model) {
            case whatifProcess.editPaymentIn:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        ClientSinglePayment: null,
                        ThirdPartySinglePayment: null,
                        ClientRegularPyament: null,
                        ThirdPartyRegularPayment: null,
                        InstrumentSelections: {
                            Type: MoneyOrPercentageType.Percentage,
                            Instruments: [],
                            DistributionDividendPreference: DistributionDividendPreference.NotSpecified,
                        },
                        [transferName]: [],
                        ChangesToBeModeled: originSelected
                            .filter((ele) => {
                                ![
                                    whatifProcess.editInvestmentSeletion,
                                    whatifProcess.editAdviserCharges,
                                    whatifProcess.editPaymentIn,
                                ].includes(ele as whatifProcess);
                            })
                            .toString(),
                    },
                });
                break;
            case whatifProcess.editAdviserCharges:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        InitialAdviserCharge: null,
                        OngoingAdviceCharge: null,
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            case whatifProcess.AddAdditionalAdviserCharge:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        AdHocAdviserCharge: { Amount: null, Currency: CurrencyCode.GBP },
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            case whatifProcess.AddEditRegularWithdrawals:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        RegularWithdrawalModel: [],
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            case whatifProcess.AddOneOffWithdrawal:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        OneOffWithdrawal: {
                            ...data?.Contribution?.OneOffWithdrawal,
                            Amount: { Amount: null, Currency: CurrencyCode.GBP },
                        },
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            case whatifProcess.ConvertCappedToFlexi:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            case whatifProcess.TakePensionBenefits:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            default:
                break;
        }
    };

    private formatChangesToBeModeled(orgin = "", add: string[]) {
        const orginArray = (orgin || "").split(",");
        const newArray = orginArray.concat(add).filter((ele) => ele !== "");
        return newArray.toString();
    }

    private prepopulateData = (model: whatifProcess) => {
        const { data, onChange, extraInfo } = this.props;
        const origin = data?.Contribution?.ChangesToBeModeled || "";
        const add = [model];
        switch (model) {
            case whatifProcess.editPaymentIn:
                add.push(whatifProcess.editInvestmentSeletion);
                if (!origin.split(",").includes(whatifProcess.editAdviserCharges)) {
                    add.push(whatifProcess.editAdviserCharges);
                }
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        ClientRegularPayment: extraInfo?.ClientRegularPayment
                            ? {
                                ...extraInfo?.ClientRegularPayment,
                                WasPaymentChanged: true,
                                FirstCollectionDate: extraInfo?.ClientRegularPayment?.NextPaymentDate,
                            }
                            : null,
                        ThirdPartyRegularPayment: extraInfo?.ThirdPartyRegularPayment
                            ? {
                                ...extraInfo?.ThirdPartyRegularPayment,
                                WasPaymentChanged: true,
                                FirstCollectionDate: extraInfo?.ThirdPartyRegularPayment?.NextPaymentDate,
                            }
                            : null,
                        InstrumentSelections: extraInfo?.InstrumentSelections,
                        OngoingAdviceCharge: extraInfo?.OngoingAdviceCharge,
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                });
                break;
            case whatifProcess.editAdviserCharges:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        OngoingAdviceCharge: extraInfo?.OngoingAdviceCharge,
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                });
                break;
            case whatifProcess.AddAdditionalAdviserCharge:
                this.onDataChange(
                    onChange,
                    {
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                    data,
                    "Contribution"
                );
                break;
            case whatifProcess.AddEditRegularWithdrawals:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        RegularWithdrawalModel: extraInfo?.RegularWithdraws,
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                });
                break;
            case whatifProcess.AddOneOffWithdrawal:
                this.onDataChange(
                    onChange,
                    {
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                    data,
                    "Contribution"
                );
                break;
            case whatifProcess.ConvertCappedToFlexi:
                this.onDataChange(
                    onChange,
                    {
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                    data,
                    "Contribution"
                );
                break;
            case whatifProcess.TakePensionBenefits:
                this.onDataChange(
                    onChange,
                    {
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                    data,
                    "Contribution"
                );
                break;
            case whatifProcess.EditIncomeDrawdown:
                this.onDataChange(
                    onChange,
                    {
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                    data,
                    "Contribution"
                );
                break; case whatifProcess.EditIncomePayments:
                this.onDataChange(
                    onChange,
                    {
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                    data,
                    "Contribution"
                );
                break; case whatifProcess.SIPPOneOffIncomePayment:
                this.onDataChange(
                    onChange,
                    {
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                    data,
                    "Contribution"
                );
                break;
            default:
                break;
        }
    };

    private getOptions = () => {
        const { data, type } = this.props;
        const selectedModel = (data?.Contribution?.ChangesToBeModeled || "").split(",");
        const options = [];
        const preRetirementArrangements = this.props.pensionArrangements.filter((ele) => { return ele.Type == PensionArrangementType.Accumulation && ele.Status == PensionArrangementStatus.Active });
        const postRetirementFlexiArrangements = this.props.pensionArrangements.filter((ele) => { return ele.Type == PensionArrangementType.Fad && ele.Status == PensionArrangementStatus.Active });
        const postRetirementCappedArrangements = this.props.pensionArrangements.filter((ele) => { return ele.Type == PensionArrangementType.Capped && ele.Status == PensionArrangementStatus.Active });
        let preRetirementPotExists = false;
        this.state.pensionArrangements.forEach((ele) => {
            if (ele.Type === PensionArrangementType.Accumulation && this.state.pensionArrangementValuations.find(val => val.ArrangementId === ele.Id)?.Percentage > 0) {
                preRetirementPotExists = true;
            }
        });
        
        (SubAccountTypeHelper.isOnPlatformPension(type) ? whatIfSippModelArray : whatIfModelArray).forEach((process) => {

            if ((process == whatifProcess.TakePensionBenefits && (!preRetirementPotExists || type === SubAccountType.JuniorSipp))
                // Comment out for R64 in SLP-174563, to be fixed post R64
                //|| (process == whatifProcess.ConvertCappedToFlexi && postRetirementCappedArrangements.length == 0)
                || (process == whatifProcess.EditIncomeDrawdown && (type == SubAccountType.JuniorSipp || preRetirementArrangements.length == 0 || !this.hasRegularCrystallisation()))
                || (process == whatifProcess.EditIncomePayments && postRetirementFlexiArrangements.length == 0 && postRetirementCappedArrangements.length == 0)
                || (process == whatifProcess.SIPPOneOffIncomePayment && postRetirementFlexiArrangements.length == 0 && postRetirementCappedArrangements.length == 0)) {
                return;
            }
            options.push({
                label: process,
                value: selectedModel.includes(process),
                disabled:
                    process == whatifProcess.editInvestmentSeletion ||
                    (process == whatifProcess.editAdviserCharges && selectedModel.includes(whatifProcess.editPaymentIn)),
                onChange: (v) => {
                    if (v) {
                        this.prepopulateData(process);
                    } else {
                        this.clearData(process);
                    }
                },
            });
        });

        return options;
    };

    private hasRegularCrystallisation() {
        return this.props.regularDrawdown && this.props.regularDrawdown.Id > 0;
    }

    public render(): JSX.Element {
        const options = this.getOptions();
        const account = ClientAccountStore.getClientAccountInfo()?.SubAccounts.find(
            (ele) => ele.HierarchyId == getQueryParameters()["subaccounthierarchyid"]
        );
        return (
            <>
                <h2>{`${account?.ProductDisplayName} ${account?.ClAccountId}`}</h2>
                {SectionHeader("Changes to be modelled")}
                <CheckboxGroup options={options} type={"panel"} wrapCss="control-size-430" />
            </>
        );
    }
}
